export default {
  listLiquidity: {
    COM_GROUP_CODE: 'comGroupCode',
    TOTAL_VALUE: 'totalValue',
    TOTAL_VOLUME: 'totalVolume',
    TRADING_DATE: 'tradingDate',
  },
  listIndex: {
    COM_GROUP_CODE: 'comGroupCode',
    INDEX_VALUE: 'indexValue',
    TRADING_DATE: 'tradingDate',
    INDEX_CHANGE: 'indexChange',
    PERCENT_INDEX_CHANGE: 'percentIndexChange',
    REFERENCE_INDEX: 'referenceIndex',
    OPEN_INDEX: 'openIndex',
    CLOSE_INDEX: 'closeIndex',
    HIGHEST_INDEX: 'highestIndex',
    LOWEST_INDEX: 'lowestIndex',
    MATCH_VOLUME: 'matchVolume',
    MATCH_VALUE: 'matchValue',
    TOTAL_MATCH_VOLUME: 'totalMatchVolume',
    TOTAL_MATCH_VALUE: 'totalMatchValue',
  },
  timeRange: {
    ONE_DAY: 'OneDay',
    FIVE_DAYS: 'OneWeek',
    TEN_DAYS: 'TwoWeeks',
    ONE_MONTH: 'OneMonth',
  },
  displayTimeRange: {
    OneDay: '1D',
    OneWeek: '5D',
    TwoWeeks: '10D',
    OneMonth: '1M',
  },
  listComGroupCodeFilter: [
    'VNINDEX',
    'HNXIndex',
    'UpcomIndex',
    'VN30',
    'HNX30',
  ],
  listFilterByComGroupCode: {
    VNINDEX: {key: 'VNINDEX', name: 'HOSE'},
    HNXIndex: {key: 'HNXIndex', name: 'HNX'},
    UpcomIndex: {key: 'UpcomIndex', name: 'UPCOM'},
    VN30: {key: 'VN30', name: 'VN30'},
    HNX30: {key: 'HNX30', name: 'HNX30'},
  },
  defaultComGroupCode: 'VNINDEX',
}
